import { Helmet } from "react-helmet-async";
import { useEffect, useState } from "react";
import { Container } from "react-bootstrap";
import { useNavigate, useParams } from "react-router-dom";
import { useAlert } from "../../../../context/AlertContext";
import { useLoading } from "../../../../context/LoadingContext";
import {
  addEditServiceRequest,
  getServiceRequest
} from "../../../../commons/ServiceRequest";
import WarrantyPeriodForm from "../../../../components/GeneralForm/WarrantyPeriodForm";
import WarrantiesService from "../../../../services/warranty.service";

export default function EditWarrantyPeriod() {
  const navigate = useNavigate();
  const { id } = useParams();
  const { showAlert } = useAlert();
  const { setLoading } = useLoading();
  const [editData, setEditData] = useState(null);

  useEffect(() => {
    getServiceRequest({
      showAlert,
      setLoading,
      serviceRequest: WarrantiesService.getWarranties(id),
      callback: (res) => setEditData(res)
    });
  }, []);

  return (
    <>
      <Helmet>
        <title>แก้ไขอายุรับประกัน</title>
        <meta name="description" content="Edit Warranty Period Page" />
      </Helmet>

      <Container fluid className="p-3">
        <WarrantyPeriodForm
          editData={editData}
          onSubmitCallback={(data) =>
            addEditServiceRequest({
              showAlert,
              setLoading,
              serviceRequest: WarrantiesService.editWarranties(id, data),
              navigated: (navi) => navi && navigate(0)
            })
          }
        />
      </Container>
    </>
  );
}
